module.exports = __webpack_public_path__ + "static/media/1.48ebff89.png";